<article class="program-sub-domain-container">
  <div class="program-sub-domain">
    <app-departments-details-side-menu
      class="side-menu"
      [selectedDepartment]="selectedDepartment!"
    ></app-departments-details-side-menu>

    <div class="sub-domain"><router-outlet></router-outlet></div>
  </div>
</article>
